import React from 'react';
import './PortfolioClientSay.scss';
import './PortfolioClientSayResponsive.scss';
import scheduale from 'assets/images/common-image/scheduale.jpg';
import google from 'assets/images/common-image/google-icon.png';
import { Link } from 'react-router-dom';

const PortfolioClientSay = ({ data }) => {
	return (
		<>
			<section className="PortfolioClientSay">
				<div className="container">
					<div className="row align-items-center">
						<div className="col-lg-4 col-md-4 col-sm-12 col-12">
							<h2 dangerouslySetInnerHTML={{ __html: data?.heading ?? `<span>Don’t take it from us.</span> Hear from our clients:` }}>

							</h2>
						</div>
						<div className="col-lg-8 col-md-8 col-sm-12 col-12">
							<div className="testiContent">
								<p dangerouslySetInnerHTML={{
									__html: data?.description ?? `Getweb is the best software development company we’ve worked with so far. Unlike many developers, they understand UI/UX design on a fundamental
									level and create a smooth user journey no matter the technical difficulties. Highly recommended if you want your digital solution highly
									innovative and impactful!` }}>

								</p>
								<div className="d-flex flex-wrap justify-content-between align-items-center">
									<ul className="d-flex align-items-center">
										<li className="clintImg">
											<span>
												<img src={data?.avatar ? `${process.env.REACT_APP_RESOURCE_URL}/${data?.avatar}` : scheduale} alt="" />
											</span>
										</li>
										<li className="clintInfo">
											<h5 dangerouslySetInnerHTML={{
												__html: data?.clientName ?? `Jacob Eiting`
											}}></h5>
											<h6 dangerouslySetInnerHTML={{
												__html: data?.clientDesignation ?? `CEO & Co-Founder`
											}}></h6>
										</li>
									</ul>
									<div className="link_wrap">
										<div className="headIcon">
											<Link to={'/'}>
												<img src={data?.logo ? `${process.env.REACT_APP_RESOURCE_URL}/${data?.logo}` : google} alt="" />
											</Link>
										</div>
									</div>
								</div>
							</div>
						</div>
						<div className="col-12"></div>
					</div>
				</div>
			</section>
		</>
	);
};

export default PortfolioClientSay;
